"use client"

import * as React from 'react';
import { M as MediaRemoteControl, a as MediaPlayerInstance } from './vidstack-DD0YAtlF.js';
import { u as useMediaContext } from './vidstack-BthB6HyT.js';

function useMediaRemote(target) {
  const media = useMediaContext(), remote = React.useRef();
  if (!remote.current) {
    remote.current = new MediaRemoteControl();
  }
  React.useEffect(() => {
    const ref = target && "current" in target ? target.current : target, isPlayerRef = ref instanceof MediaPlayerInstance, player = isPlayerRef ? ref : media?.player;
    remote.current.setPlayer(player ?? null);
    remote.current.setTarget(ref ?? null);
  }, [media, target && "current" in target ? target.current : target]);
  return remote.current;
}

export { useMediaRemote as u };
